<template>
  <Row
    class="page3 financingInner"
    style="padding-left: 4vw; padding-right: 4vw"
  >
    <div
      style="
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 88;
        left: 0;
        top: 2.5vw;
      "
    >
      <div class="changeWrap">
        <!-- <img :src="$images.change" alt="" /> -->
        <!-- <span>切换</span> -->
      </div>
      <div style="display: flex; align-items: center">
        <!-- <img
          @click="$router.back()"
          :src="$images.logo"
          style="width: 3vw; height: 3vw; cursor: pointer"
          alt=""
        /> -->
        <Select
          style="width: 100px; margin-left: 15px"
          placeholder="请选择年份"
          class="myselect"
          v-model="year"
        >
          <Option :value="item" v-for="item in arrYear" :key="item">{{
            item
          }}</Option>
        </Select>
        <Select
          style="width: 100px; margin-left: 15px"
          placeholder="请选择月份"
          class="myselect"
          v-model="month"
        >
          <Option :value="item" v-for="item in arrMonth" :key="item">{{
            item
          }}</Option>
        </Select>
        <Button
          @click="choseYearMonth()"
          type="warning"
          ghost
          style="
            cursor: pointer;
            margin-left: 15px;
            color: #bf9d63;
            border: solid 1px #bf9d63;
          "
          >完成</Button
        >
      </div>
    </div>
    <el-dialog
      class="platedialog"
      title="关联关系图谱"
      top="0"
      :visible.sync="dialogVisible"
      width="100%"
    >
      <div class="echartRelate" style="height: 100vh">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          id="svgId"
          height="1000"
          width="100%"
        ></svg>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <div class="part1" v-if="step == 'part1'">
      <div class="top">
        <div class="left">合同文本识别</div>
        <div class="right">
          <Button
            type="warning"
            style="border: 1px solid #4d4a48; background: #bf9d63"
            @click="step = 'part2'"
            >点击确认</Button
          >
        </div>
      </div>
      <div class="flow">
        <div class="yellowCorner">
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">上游</div>
          </div>
          <div class="flowCenter overHeight">
            <!-- <div class="loadingWrap">
              <el-progress
                type="circle"
                :percentage="10"
                :width="70"
                color="#BF9D63"
              ></el-progress>
              <div class="word">正在上传...</div>
            </div> -->
            <div class="content1" v-if="content1">{{ content1 }}</div>
            <el-upload
              v-else
              class="upload-demo"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :http-request="(e) => uploadFile(e, 'up')"
              :limit="1"
              name="cover"
              :multiple="false"
              :auto-upload="true"
              :show-file-list="false"
            >
              <el-button class="uploadButton" slot="trigger" type="primary"
                >上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
            </el-upload>
          </div>
          <div class="flowRight overHeight">
            <div class="content2" v-if="content2">{{ content2 }}</div>
            <div class="noContent" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="47"
                height="50"
                viewBox="0 0 57 70"
                fill="none"
              >
                <g clip-path="url(#clip0_2379_509)">
                  <path
                    d="M57.0112 66.6329C57.0112 68.4599 55.8076 69.9472 54.3171 69.9472L2.77231 70C1.28182 70 0.0745244 68.5165 0.0707982 66.6857L0 3.3558C0 1.50992 1.20357 0.0377481 2.69406 0.0377481L40.6158 0L56.9478 15.5182L57.0112 66.6329Z"
                    fill="#5E5E5E"
                  />
                  <path
                    d="M57.0093 15.922H43.2447C41.7542 15.922 40.5469 14.4423 40.5469 12.6115V0.388672L57.0093 15.922Z"
                    fill="#BF9D63"
                  />
                  <path
                    d="M42.9861 26.5104C42.9861 26.7288 42.9436 26.9451 42.861 27.1469C42.7784 27.3486 42.6573 27.5319 42.5046 27.6862C42.352 27.8405 42.1708 27.9627 41.9714 28.046C41.7721 28.1292 41.5585 28.1718 41.3429 28.1713H14.2682C13.8464 28.1509 13.4485 27.9669 13.1571 27.6573C12.8657 27.3477 12.7031 26.9363 12.7031 26.5085C12.7031 26.0807 12.8657 25.6694 13.1571 25.3598C13.4485 25.0501 13.8464 24.8661 14.2682 24.8457H41.3615C41.7944 24.8497 42.2082 25.027 42.5125 25.3388C42.8169 25.6507 42.9871 26.0718 42.9861 26.5104ZM42.9861 38.9673C42.9861 39.1857 42.9436 39.402 42.861 39.6037C42.7784 39.8055 42.6573 39.9888 42.5046 40.143C42.352 40.2973 42.1708 40.4196 41.9714 40.5028C41.7721 40.5861 41.5585 40.6287 41.3429 40.6282H14.2682C13.8464 40.6078 13.4485 40.4237 13.1571 40.1141C12.8657 39.8045 12.7031 39.3931 12.7031 38.9654C12.7031 38.5376 12.8657 38.1262 13.1571 37.8166C13.4485 37.507 13.8464 37.3229 14.2682 37.3026H41.3615C41.5774 37.3021 41.7914 37.3448 41.9909 37.4283C42.1905 37.5117 42.3719 37.6343 42.5246 37.789C42.6773 37.9437 42.7983 38.1274 42.8807 38.3296C42.9631 38.5318 43.0053 38.7485 43.0048 38.9673H42.9861ZM42.9861 52.2659C42.9861 52.4843 42.9436 52.7006 42.861 52.9024C42.7784 53.1041 42.6573 53.2874 42.5046 53.4417C42.352 53.596 42.1708 53.7182 41.9714 53.8015C41.7721 53.8847 41.5585 53.9273 41.3429 53.9268H14.2682C13.8464 53.9064 13.4485 53.7224 13.1571 53.4128C12.8657 53.1032 12.7031 52.6918 12.7031 52.264C12.7031 51.8362 12.8657 51.4249 13.1571 51.1153C13.4485 50.8056 13.8464 50.6216 14.2682 50.6012H41.3615C41.7973 50.6012 42.2153 50.7766 42.5235 51.0888C42.8316 51.401 43.0048 51.8244 43.0048 52.2659H42.9861Z"
                    fill="#BF9D63"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2379_509">
                    <rect width="57" height="70" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div class="noword">暂无分析结果</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flow" style="margin-top: 3vh">
        <div class="yellowCorner">
          <div class="flowLeft">
            <div class="dot"></div>
            <div class="word">下游</div>
          </div>
          <div class="flowCenter overHeight">
            <div class="content1" v-if="content3">{{ content3 }}</div>

            <el-upload
              v-else
              class="upload-demo"
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :http-request="(e) => uploadFile(e, 'down')"
              :limit="1"
              name="cover"
              :multiple="false"
              :auto-upload="true"
              :show-file-list="false"
            >
              <el-button class="uploadButton" slot="trigger" type="primary"
                >上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
            </el-upload>
          </div>
          <div class="flowRight overHeight">
            <div class="content2" v-if="content4">{{ content4 }}</div>

            <div class="noContent">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="47"
                height="50"
                viewBox="0 0 57 70"
                fill="none"
              >
                <g clip-path="url(#clip0_2379_509)">
                  <path
                    d="M57.0112 66.6329C57.0112 68.4599 55.8076 69.9472 54.3171 69.9472L2.77231 70C1.28182 70 0.0745244 68.5165 0.0707982 66.6857L0 3.3558C0 1.50992 1.20357 0.0377481 2.69406 0.0377481L40.6158 0L56.9478 15.5182L57.0112 66.6329Z"
                    fill="#5E5E5E"
                  />
                  <path
                    d="M57.0093 15.922H43.2447C41.7542 15.922 40.5469 14.4423 40.5469 12.6115V0.388672L57.0093 15.922Z"
                    fill="#BF9D63"
                  />
                  <path
                    d="M42.9861 26.5104C42.9861 26.7288 42.9436 26.9451 42.861 27.1469C42.7784 27.3486 42.6573 27.5319 42.5046 27.6862C42.352 27.8405 42.1708 27.9627 41.9714 28.046C41.7721 28.1292 41.5585 28.1718 41.3429 28.1713H14.2682C13.8464 28.1509 13.4485 27.9669 13.1571 27.6573C12.8657 27.3477 12.7031 26.9363 12.7031 26.5085C12.7031 26.0807 12.8657 25.6694 13.1571 25.3598C13.4485 25.0501 13.8464 24.8661 14.2682 24.8457H41.3615C41.7944 24.8497 42.2082 25.027 42.5125 25.3388C42.8169 25.6507 42.9871 26.0718 42.9861 26.5104ZM42.9861 38.9673C42.9861 39.1857 42.9436 39.402 42.861 39.6037C42.7784 39.8055 42.6573 39.9888 42.5046 40.143C42.352 40.2973 42.1708 40.4196 41.9714 40.5028C41.7721 40.5861 41.5585 40.6287 41.3429 40.6282H14.2682C13.8464 40.6078 13.4485 40.4237 13.1571 40.1141C12.8657 39.8045 12.7031 39.3931 12.7031 38.9654C12.7031 38.5376 12.8657 38.1262 13.1571 37.8166C13.4485 37.507 13.8464 37.3229 14.2682 37.3026H41.3615C41.5774 37.3021 41.7914 37.3448 41.9909 37.4283C42.1905 37.5117 42.3719 37.6343 42.5246 37.789C42.6773 37.9437 42.7983 38.1274 42.8807 38.3296C42.9631 38.5318 43.0053 38.7485 43.0048 38.9673H42.9861ZM42.9861 52.2659C42.9861 52.4843 42.9436 52.7006 42.861 52.9024C42.7784 53.1041 42.6573 53.2874 42.5046 53.4417C42.352 53.596 42.1708 53.7182 41.9714 53.8015C41.7721 53.8847 41.5585 53.9273 41.3429 53.9268H14.2682C13.8464 53.9064 13.4485 53.7224 13.1571 53.4128C12.8657 53.1032 12.7031 52.6918 12.7031 52.264C12.7031 51.8362 12.8657 51.4249 13.1571 51.1153C13.4485 50.8056 13.8464 50.6216 14.2682 50.6012H41.3615C41.7973 50.6012 42.2153 50.7766 42.5235 51.0888C42.8316 51.401 43.0048 51.8244 43.0048 52.2659H42.9861Z"
                    fill="#BF9D63"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2379_509">
                    <rect width="57" height="70" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <div class="noword">暂无分析结果</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part2" v-if="step == 'part2'">
      <div class="topList">
        <div class="item" v-for="item in contractTopList">
          <div class="yellowCorner">
            <div class="itemTitle" style="font-size: 0.9vw">
              {{ item.name }}
            </div>
            <div class="content">
              <span class="num" style="font-size: 1.5vw">{{ item.num }}</span>
              <span class="unit">{{ item.unit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="tableWrap">
        <div class="yellowCorner overHeight">
          <div class="tableList overHeight">
            <div class="titleWrap borderRight borderTop BorderBottom">
              <div>
                <div
                  class="padding1 borderLeft borderRight"
                  style="width: 16vw"
                >
                  上游
                </div>
                <div style="display: flex; align-items: center">
                  <div
                    class="padding1 borderLeft borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    合同编号
                  </div>
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    合同文本
                  </div>
                </div>
              </div>
              <div>
                <div
                  class="padding1 borderRight borderBottom"
                  style="width: 16vw"
                >
                  下游
                </div>
                <div style="display: flex; align-items: center">
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    合同编号
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    合同文本
                  </div>
                </div>
              </div>
              <div
                class="padding1 borderRight borderBottom"
                style="
                  display: flex;
                  align-items: center;
                  width: 8vw;
                  height: 4vw;
                "
              >
                检查编号
              </div>
              <div>
                <div class="padding1 borderRight" style="width: 40vw">
                  检查项目
                </div>
                <div style="display: flex; align-items: center">
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    上游合同条款
                  </div>
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    下游合同条款
                  </div>
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    货权异常
                  </div>
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    资金异常
                  </div>
                  <div
                    class="padding1 borderTop borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    关联关系
                  </div>
                </div>
              </div>
              <div
                style="
                  width: 9.6vw;
                  height: 4vw;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                class="borderBottom"
              >
                是否预警
              </div>
            </div>
            <div
              v-for="item in paginatedData"
              class="titleWrap borderRight BorderBottom"
              style="background: none; color: #fff"
            >
              <div>
                <div style="display: flex; align-items: center">
                  <div
                    class="padding1 borderLeft borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    {{ item["上游合同编号"] }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-link
                      target="_blank"
                      href="https://community.gmfintl.com/brightfood_platform_pc/#/disfinancingtrade"
                      type="warning"
                      style="color: #bf9d63"
                      >点击查看详情</el-link
                    >
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    {{ item["下游合同编号"] }}
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-link
                      target="_blank"
                      href="https://community.gmfintl.com/brightfood_platform_pc/#/disfinancingtrade"
                      type="warning"
                      style="color: #bf9d63"
                      >点击查看详情</el-link
                    >
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                  <el-popover
                      v-if="JSON.stringify(item['检查编号']).indexOf('{') > -1"
                      :popper-options="{
                        boundariesElement: 'viewport',
                        removeOnDestroy: true,
                      }"
                      popper-class="popoverBackB"
                      placement="left"
                      width="400"
                      trigger="hover"
                    >
                      <div class="hoverContent">
                        <div class="hovertitle">
                          {{ item["检查编号"]["listUp"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["检查编号"]["listUp"]["answer"] }}
                        </div>
                      </div>
                      <div slot="reference" style="cursor: pointer">
                        {{ item["检查编号"].value }}
                      </div>
                    </el-popover>
                    <div v-else>{{ item['检查编号'] }}</div>
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-popover
                      :popper-options="{
                        boundariesElement: 'viewport',
                        removeOnDestroy: true,
                      }"
                      popper-class="popoverBackB"
                      placement="left"
                      width="400"
                      trigger="hover"
                    >
                      <div class="hoverContent">
                        <div class="hovertitle">
                          {{ item["上游合同条款"]["listUp"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["上游合同条款"]["listUp"]["answer"] }}
                        </div>
                      </div>
                      <div slot="reference" style="cursor: pointer">
                        {{ item["上游合同条款"]["value"] }}
                      </div>
                    </el-popover>
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-popover
                      :popper-options="{
                        boundariesElement: 'viewport',
                        removeOnDestroy: true,
                      }"
                      popper-class="popoverBackB"
                      placement="left"
                      width="400"
                      trigger="hover"
                    >
                      <div class="hoverContent">
                        <div class="hovertitle">
                          {{ item["下游合同条款"]["listUp"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["下游合同条款"]["listUp"]["answer"] }}
                        </div>
                      </div>
                      <div slot="reference" style="cursor: pointer">
                        {{ item["下游合同条款"]["value"] }}
                      </div>
                    </el-popover>
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-popover
                      :popper-options="{
                        boundariesElement: 'viewport',
                        removeOnDestroy: true,
                      }"
                      popper-class="popoverBackB"
                      placement="left"
                      width="400"
                      trigger="hover"
                    >
                      <div class="hoverContent">
                        <div class="hovertitle">
                          {{ item["疑似无货权"]["listUp"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["疑似无货权"]["listUp"]["answer"] }}
                        </div>
                      </div>
                      <div slot="reference" style="cursor: pointer">
                        {{ item["疑似无货权"]["value"] }}
                      </div>
                    </el-popover>
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <el-popover
                      :popper-options="{
                        boundariesElement: 'viewport',
                        removeOnDestroy: true,
                      }"
                      popper-class="popoverBackB"
                      placement="left"
                      width="400"
                      trigger="hover"
                    >
                      <div class="hoverContent">
                        <div class="hovertitle">
                          {{ item["资金垫付"]["listUp"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["资金垫付"]["listUp"]["answer"] }}
                        </div>
                        <div class="line"></div>
                        <div class="hovertitle">
                          {{ item["资金垫付"]["listDown"]["question"] }}
                        </div>
                        <div class="content">
                          {{ item["资金垫付"]["listDown"]["answer"] }}
                        </div>
                      </div>
                      <div slot="reference" style="cursor: pointer">
                        {{ item["资金垫付"]["value"] }}
                      </div>
                    </el-popover>
                  </div>
                  <div
                    class="padding1 borderRight borderBottom"
                    style="width: 8vw; text-align: center"
                  >
                    <span
                      @click="showSvg(item['关联关系']['relation'])"
                      style="cursor: pointer"
                      >{{ item["关联关系"]["value"] }}</span
                    >
                  </div>
                  <div
                    class="padding1 borderBottom"
                    style="width: 9.6vw; text-align: center"
                  >
                    {{ item["是否预警"] }}
                  </div>
                </div>
              </div>
            </div>
            <el-pagination
              style="text-align: right; margin-top: 1vw"
              background
              :current-page.sync="currentPage"
              layout="prev, pager, next"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </Row>
</template>

<script>
import { useDataStore } from "@/store";
import { mapActions } from "pinia";
import { Loading } from "element-ui";
import relationJson from "./relation.json";
import * as d3 from "d3";

// ===== 绘图 =====
function drawMarker() {
  d3.select("svg")
    .append("svg:defs")
    .append("svg:marker")
    .attr("id", "blueMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", (d) => {
      return "#000000";
    });
  d3.select("svg")
    .select("defs")
    .append("svg:marker")
    .attr("id", "redMarker")
    .attr("viewBox", "0 -5 10 10")
    .attr("refX", 70)
    .attr("refY", 0)
    .attr("markerUnits", "userSpaceOnUse")
    .attr("markerWidth", 6)
    .attr("markerHeight", 6)
    .attr("orient", "auto")
    .append("svg:path")
    .attr("d", "M0,-5L10,0L0,5")
    .attr("fill", "#fd6568");
}

function drawCircle(id) {
  let circleG = d3.select(`#${id}`).attr("class", "circle-g");
  circleG
    .append("circle")
    .attr("class", "real-circle")
    .attr("fill", (d) => {
      // 某个企业详情页点击进来的，给个这个企业特殊样式
      if (d.isSelf) {
        return "#fe9d3b";
      }
      if (String(d.type).indexOf("important") > -1) {
        return "#fe5557";
      }
      if (String(d.type).indexOf("person") > -1) {
        return "#4d2fe1";
      }
      return "#52a3eb";
    })
    .attr("stroke", function (d) {
      if (d.isSelf) {
        return "#ec8a2f";
      } else if (String(d.type).indexOf("person") > -1) {
        return "#0082e5";
      }
      return "none";
    })
    .attr("x", (d) => {
      return d.x})
      .attr("y", (d) => {
      return d.y})
    // 设置圆圈半径
    .attr("r", (d) => {
      return d.r
      if (String(d.type).indexOf("person") > -1) {
        return 23;
      }
      if (String(d.type).indexOf("important") > -1) {
        return 48;
      }
      return 35;
    });
}

function drawText(id) {
  d3.select(`#${id}`)
    .insert("text")
    .attr("class", "circle-text")
    .attr("dy", ".35em")
    .attr("text-anchor", "middle")
    .attr("font-size", 12)
    .style("fill", function (node) {
      return "#fff";
    })
    .attr("y", (d) => {
      return d.x;
    })
    .attr("x", function (d) {
      let re_en = /[a-zA-Z]+/g;
      //如果是全英文，不换行
      if (d.name.match(re_en)) {
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      }
      //如果小于四个字符，不换行
      else if (d.name.length <= 4) {
        d3.select(this)
          .append("tspan")
          .attr("x", -2)
          .attr("y", 2)
          .text(function () {
            return d.name;
          });
      } else if (d.name.length > 4 && d.name.length <= 8) {
        //大于4  这两行
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot;
          });
      }
      // 文字长度大于8 折三行
      else if (d.name.length > 8 && d.name.length <= 12) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -15)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 2)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 16)
          .text(function () {
            return bot1;
          });
      }
      //文字长度大于12 折四行
      else if (d.name.length > 12 && d.name.length <= 16) {
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, d.name.length);

        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -20)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -3)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 23)
          .text(function () {
            return bot2;
          });
      } else if (d.name.length > 16) {
        //文字长度大于16  方案
        let top = d.name.substring(0, 4);
        let bot = d.name.substring(4, 8);
        let bot1 = d.name.substring(8, 12);
        let bot2 = d.name.substring(12, 14);

        bot2 += "...";
        d3.select(this).text(function () {
          return "";
        });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -22)
          .text(function () {
            return top;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", -7)
          .text(function () {
            return bot;
          });

        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 10)
          .text(function () {
            return bot1;
          });
        d3.select(this)
          .append("tspan")
          .attr("x", 0)
          .attr("y", 25)
          .text(function () {
            return bot2;
          });
      }
    });
}

function drawLinkPath(container, links) {
  // 添加连接路径path
  container
    .append("g")
    .attr("class", "line-path")
    .selectAll(".path")
    .data(links)
    .enter()
    .append("path")
    .attr("class", "path")
    .attr("fill", "none")
    .attr("stroke-dasharray", function (d) {
      if (String(d.type).indexOf("dash") > -1) {
        return 5.5;
      }
      return "none";
    })
    .attr("stroke-width", 1)
    .attr("stroke", function (d) {
      if (d.color) {
        return d.color;
      }
      return "#000000";
    })
    .attr("marker-end", function (d) {
      let id = "blueMarker";
      if (d.type === "投资") {
        id = "redMarker";
      }
      return `url(#${id})`;
    })
    .attr("cursor", "pointer");
}

function drawRelationText(container, links,linkGroup) {
  for(let i in linkGroup){
    let edges_text = container
    .append("g")
    .attr("class", "relation-text")
    .selectAll(".linetext")
    .data(linkGroup[i])
    .enter()
    .append("svg:g")
    .attr("class", "linetext")
    .attr("fill-opacity", 1);

    edges_text
    .append("svg:text")
    .attr("font-size", 10)
    .attr("fill", "#8e8e8e")
    .attr("y", ".31em")
    .attr("dy", function(d,i){
      return (i+1.5)+'em'
    })
    .attr("text-anchor", "middle")
    .text(function (d) {
      return d.value;
    });
  }
  //边上的文字（人物之间的关系）
  // let edges_text = container
  //   .append("g")
  //   .attr("class", "relation-text")
  //   .selectAll(".linetext")
  //   .data(links)
  //   .enter()
  //   .append("svg:g")
  //   .attr("class", "linetext")
  //   .attr("fill-opacity", 1);

  // edges_text
  //   .append("svg:text")
  //   .attr("font-size", 10)
  //   .attr("fill", "#8e8e8e")
  //   .attr("y", ".31em")
  //   .attr("text-anchor", "middle")
  //   .text(function (d) {
  //     return d.value;
  //   });

  // edges_text
  //   .insert("rect", "text")
  //   .attr("width", function (d, i, e) {
  //     let { width } = e[i].parentNode.getBoundingClientRect();
  //     return width;
  //   })
  //   .attr("height", function (d) {
  //     return 14;
  //   })
  //   .attr("y", "-.5em")
  //   .attr("x", function (d, i, e) {
  //     let { width } = e[i].nextSibling.getBoundingClientRect();
  //     return -width / 2;
  //   })
  //   .attr("fill", "rgba(255,255,255,.5)");
}

function formatNode(nodes) {
  let name = "";
  nodes.forEach((node) => {
    if (name === node.name) {
      node.isSelf = true;
    }
    node.idx = "zf" + uuid();
  });
}
// 格式化连接关系数据
function formatLink(links, nodes) {
  links.forEach((link, i) => {
    link.index = i;
    let src = nodes.find((node) => node.name == link.source);
    let dst = nodes.find((node) => node.name == link.target);
    link["source"] = src;
    link["target"] = dst;
  });
}
function uuid() {
  return Math.random().toString(34).replaceAll(/\,|\./g, "");
}

// ===== 更新 =====
function tick() {
  try {
    updateLinkLine();
    updateCircleAndText();
    updateLinkRelationText();
  } catch (error) {
    console.error("Error in tick:", error);
  }
}
function updateCircleAndText() {
  d3.selectAll("circle")
    .attr("cx", (d) => {
      return d.x;
    })
    .attr("cy", (d) => d.y);
  d3.selectAll(".circle-text").attr("transform", (d) => {
    return `translate(${d.x},${d.y})`;
  });
}
function updateLinkLine() {
  let edges_line = d3.selectAll(".path");
  edges_line.attr("d", function (d) {
    return (
      "M" +
      d.source.x +
      " " +
      d.source.y +
      " L " +
      d.target.x +
      " " +
      d.target.y
    );
  });
}
function updateLinkRelationText() {
  let svg = d3.select("svg");
  let edges_text = svg.selectAll(".linetext");

  //更新连接线上文字的位置
  edges_text.attr("transform", function (d) {
    let translateX = (d.source.x + d.target.x) / 2;
    let translateY = (d.source.y + d.target.y) / 2;
    return `translate(${translateX},${translateY}) rotate(0)`;
  });
}
export default {
  name: "page3",
  components: {},
  computed: {
    total() {
      return this.listAnswer.length;
    },
    paginatedData() {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      return this.listAnswer.slice(start, end);
    },
  },
  created() {
    this.listAnswer = relationJson;
    this.content1new = this.content1;
    this.content2new = this.content2;
    this.content3new = this.content3;
    this.content4new = this.content4;
    this.content1 = "";
    this.content2 = "";
    this.content3 = "";
    this.content4 = "";
    // sysLogin()
    this.setTitle("异常贸易检查看板");
    this.setLeftTop(false);
    this.setRightTop(false);

    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    if (day <= 15) {
      if (month == 1) {
        month = 11;
        year--;
      } else if (month == 2) {
        month = 12;
        year--;
      } else {
        month = month - 2;
      }
    } else {
      if (month == 1) {
        month = 12;
        year--;
      } else {
        month--;
      }
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.year = year;
    this.month = month;
    let beforeYear = year - 50;
    let arrYear = [];
    while (beforeYear < year) {
      arrYear.push(year--);
    }
    arrYear = arrYear.filter((item) => item > 2020);
    this.arrYear = arrYear;
    let arrMonth = [];
    for (let i = 1; i <= 12; i++) {
      let month2 = i < 10 ? "0" + i : "" + i;
      arrMonth.push(month2);
    }
    this.arrMonth = arrMonth;
  },
  data() {
    return {
      simulation: null,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      listAnswer: [],
      contractTopList: [
        {
          name: "采购合同数量",
          num: "0/？",
          unit: "个",
        },
        {
          name: "销售合同数量",
          num: "17/63+?",
          unit: "个",
        },
        {
          name: "关联关系交易对数量",
          num: "0/148+?",
          unit: "个",
        },
        {
          name: "上下游合同异常数量",
          num: "0/63+?",
          unit: "个",
        },
        {
          name: "货权异常交易对数量",
          num: "0/148+？",
          unit: "个",
        },
        {
          name: "关联关系异常数量",
          num: "0/148+？",
          unit: "个",
        },
        {
          name: "预警数量",
          num: "0",
          unit: "个",
        },
      ],
      dialogVisible: false,
      fileList: [],
      step: "part2",
      content1: `甲乙丙叁方本着互惠互利、优质服务的原则，经友好协商，就乙方为甲方代理进口货物报关、商检、运输、仓储等事宜达成如下协议，共同遵守：
一、	货物情况
1	货物名称：美国进口苜蓿草、澳大利亚燕麦草（集装箱装运）。
2	装运日期及批次：根据实际装运的货物单证为准。
3	送货目的地：按丙方《放货通知》所载明的地点和运输方式为准。
二、	乙方代理事宜
1	报检、报关；
2	进口通关、放行；
3	港口全程商品检验检疫、放行；
4	进口换单及相关操作；
5	代垫、缴纳货物进口所需港杂等费用；
6	办理免税和进口许可证申请；
7	办理其他港口交货前所必须的手续；
8	如丙方需要，乙方代理如下事宜：
8.1	将苜蓿草以集装箱拖运或掏箱配货运输的形式将苜蓿草运至丙方指定目的地。
8.2	将苜蓿草掏箱存入经丙方确认的仓库。
三、	有关大连港车板交货费用计算
    1.港口包干费：87元/吨（直提），港口包干费：98元/吨（拆箱入库），船公司费用（进口换单、THC、修洗箱费等实报实销）。
四、	甲责任和义务
1	应及时向乙方提供进口货物所需要的合法、齐全、有效的单据。每批货物抵港前1个工作日将正本提单（经甲方背书）、正本植物检疫证书、正本原产地证（国外商会出具）、商业发票、装箱单、正本报关委托书、正本报检委托书、进口合同的复印件提供给乙方；
2	丙方应派专人负责与乙方的交接等事宜，及时付清乙方费用。
3	由于甲方单证等原因（单单不符、单货不符、单证晚到）造成的滞港费用，由甲方承担。
4	丙方应确保指定卸货牧场提供足够的卸车掏箱场地、人力和机械，保证卸车能力。因丙方原因不及时卸车产生的集装箱超期使用费和车辆怠驶费用由丙方承担。因风、雪、雨、雾等恶劣天气除外。
5	甲方在收到乙方的关税缴款书传真件后2个工作日内支付给乙方，乙方收到甲方关税后代交给海关，但是乙方提前不垫付关税。
五、	乙方责任和义务
1	负责本合同第一项的进口货物自到达大连港后至送到甲方规定的最终收货人仓库的全程工作。
a)	根据甲方提供的通关单证3个工作日内完成报检、报关，确保货物可以正常放行、运输，由于乙方报检、报关和运输不及时造成的滞港费、滞箱费、码头产生的超期费用和码头搬倒费等费用由乙方承担。
2	乙方在提箱时应对集装箱的外观进行检查，包括集装箱号、铅封号、铅封是否完好、集装箱是否有遗漏、破损，如有异常请况应及时采取措施，避免损失扩大，并督促港方出具纪录。
3	及时跟码头有关部门结算有关费用，因付款不及时影响通关、提货或被有关部门课以的罚款由乙方全额承担。
4	按丙方的要求及时将货物运至丙方指定仓库。
5	协助口岸检验检疫部门现场取样验货。
6	货物在港期间，由于仓储、操作、保管不善造成的损失由乙方承担，但由于货物本身自然属性和不可抗力原因造成上述损失，乙方不承担责任。
7	及时将到港、通关、发运、港存请况和货物实际免箱期通知甲方和丙方。
8	乙方应本着为甲方高度负责的原则，如发现单单不符、单货不符时等其他特殊情况要及时告知甲方，力争节约成本、提高服务水平。
9	乙方在按照甲方指令运输货物时，应认真寻找可靠的配货站及车辆，经丙方认可运费后方可代为签定运输合同，给付运费。乙方发配货物运输途中发生货物短少或受损的情况，应先行向甲方赔付，再与承运方索赔。
10	乙方必须对甲方进口货物信息保密，不得向任何与此货物进口程序无关的第三方泄密，否则甲方有权向乙方索赔由此引起的损失，并终止合同执行。
11	乙方在提货前如发现货物破损、污染、短重等情况应及时通知甲方和丙方，并协助甲方对外索赔。
12	乙方免费协助甲方办理《中华人民共和国进境动植物检疫许可证》以及向海关申请办理免税的相关手续；
13	若出于市场考虑，需要将苜蓿草掏箱入库，乙方应确保如下事项：
13.1	 储存货物的情况
甲方将其进口货物存在乙方联络确定的仓库。乙方根据进口单证上载明的货物情况合理安排仓库，确保所安排仓库满足货物存储条件。
13.2	 货物验收
集装箱货物掏箱入库时，提供能反应本批草的颜色和质量外观的照片及对应批次苜蓿草的感官信息。每箱货物入库必须清点件数，若发现有货物破损、数量不符、毁坏情况，乙方应及时将具体情况以照片、文字与电话的形式告知甲方和丙方，同时及时采取补救措施，最大限度减少货物损失。同时在入库单记载，并于2个工作日内书面通知甲方和丙方。
13.3	 货物保管要求
乙方应按丙方要求和入库货物的特点，合理安排货物存放地点。并按照合同号分堆存放。要使其符合相应的保管条件，确保所存货物的安全及货物在质量和数量上免受任何损失。
13.4	 出入库手续
13.4.1	乙方应凭丙方传真，按要求发运相应批次的货物，因乙方疏忽大意造成发错货物，乙方应赔偿损失。乙方要在发货后以书面或短信形式通知丙方出库数量及重量（如果丙方需要过磅）。
13.5	 货物的损耗标准和损耗处理
货物仓储正常损耗为3‰（不可抗力因素除外，在外包装完好的情况下，内部损耗属正常情况，由于存储不当造成的水浸，变质等损失由乙方承担。除有特殊要求的货物外，饲草类货物保质期为6个月，由于超期所造成的自然风化，变质等损失由丙方承担。）


13.5.1	进出库费：入库完毕后，乙方出具入库单，开具相应发票给甲方结算对应提单号项下货物的进出库费。
13.5.2	仓储费：仓储费按月结算，费率为0.45/吨天（1个月内）、0.6/吨天（2-3个月）、0.8/吨天（90天后）。
六、	费用结算
1	港杂费：货物入库完毕后，结算对应入库货物的港杂费。
2	运输费用：乙方将货物送至收货人后办理货物交接手续，并将货物签收单正本交给丙方，作为结算依据。每个月25日核对当月运输的费用，相关费用经丙方确认后，乙方开具相应的货物代理发票，甲方应在收到相应发票后 10 个工作日内结算对应费用。丙方需先支付甲方费用后甲方方能向乙方支付，甲方不垫付该部分费用。
七、 甲、乙、丙叁方应认真履行本合同，未尽事宜以及在履行过程中发生的争议，叁方应友好协商解决，并以书面补充合同来确定。协商不成时，则以原告所在地人民法院为管辖法院通过诉讼程序解决。
八、本协议一式三份，三方各保存一份，签字盖章之日起生效，有效期2022年1月15日至2023年1月15日，如合作三方无异议，合同到期后可自动延续一年，传真签署具有同等效力。`,
      content2: `"根据提供的合同片段，可以看到以下内容： 
合同有三方或三方以上主体
合同片段中未出现垫付货款、资金占用、授信额度、资金额度、占用费、资金周期、委托融资、年化收益率、循环周期、逾期利息、服务费率等词汇
合同片段收货方与付款方（先付款方）是同一主体
合同片段未出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）
综上所述，根据合同片段分析，该合同并不具备融资性贸易合同的特征。 
因此，结论为""BB"""`,
      content3: `二、交货方式及交货费用承担：      甲方送到    
三、交货时间和地点：1、时间：  2023年7月 10号前     2、地点： 南平市南山生态园有限公司             
四、验货及处理1、乙方委托专人朱光辉：13859396630 ，如有变动应及时通知甲方。
2、甲方需送符合合同要求质量的货物到乙方，乙方收到货后，应及时对本批次产品的质量和数量进行确认，必须在确认饲料中黄曲霉毒素B1及亚硝酸盐均符合合同标准方可使用。
3、由于乙方未检测饲料中的黄曲霉毒素及亚硝酸盐含量就使用该批饲料，造成乙方退奶事故的，甲方不承担任何责任。如甲方送的饲料中检测出黄曲霉毒素及亚硝酸盐超标，甲方无条件退货。
4、乙方如对产品质量、数量有异议，须在到货后3个工作日内，以书面、电子邮件、短信等形式告知甲方，以便甲方及时派人协调处理。超过期限或已经使用该产品，则表示乙方已默认该批次产品质量和数量符合要求。
5、甲方在收到乙方反馈的异议信息后，应在5工作日内派人协调处理，并将处理的结果经双方签字确认后，作为本合同的附件进行保存。
6、乙方因使用、保管不善造成产品质量下降的，乙方不得提出异议。
7、乙方在铁路自提货物时，如发现数量短缺，必须提供铁路局的大票和货运记录给甲方，甲方凭货运记录和铁路大票承担短缺的数量。
五、付款方式及期限： 票到30天内付款，乙方应付款至甲方下列账户：
户名：上海鼎牛饲料有限公司，开户行：工行上海市延长中路支行，账号： 1001295109300409372。
六、违约责任1、甲方交付的饲料，如存在不符合合同约定的质量标准且无法使用，甲方最多只承担同该问题饲料货款相当的经济责任，不承担由此产生的其它间接责任。
2、乙方超过约定付款日期未付款的，甲方将按5‰日利率收取逾期货款部分的利息。分批发货的，乙方逾期未支付已到货货款的，甲方有权停止发放剩余的货物。
3、由于自然灾害、春运等不可抗力影响，造成甲方未能按时履行合同的，甲方不承担违约责任
4、若乙方发生违约责任，乙方的奶源及奶牛作为连带赔付。
5、由于价格调整，甲方有权终止执行该合同，有预付款的除外。
6、甲方未收到乙方订金或者预付款的，甲方有权单方面取消合同。`,
      content4: `根据合同片段，该合同具备融资性贸易特征。具体来说，合同中有垫付货款、资金占用、授信额度、循环周期、逾期利息、服务费率等词汇，且合同片段中出现合同的一方以自身信用向另一方提供资金融通、担保（含抵押、质押等）。同时，合同中有关于质量标准、添加剂、重量检验、违约责任等方面的规定，且存在违约金、逾期付款利息等罚则，表明合同中有融资性贸易的特征。因此，该合同具备融资性贸易特征，结论为"AA"。`,
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setRightTop"]),
    showSvg(relation) {
      if (relation) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getSvgDetail(relation);
        });
      } else {
        this.$message.info("未发现10层内关联关系");
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handlePageChange(val) {
      this.currentPage = val;
    },
    handelChange(file, fileList) {
      this.fileList = fileList;
      console.log("文件修改执行的函数", file, fileList);
    },
    handleRemove(file, fileList) {
      console.log("移除文件执行的函数", file, fileList);
      this.filesList = fileList;
    },
    handlePreview(file) {
      console.log("点击已经上传的文件", file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      console.log("移除之前执行的函数", fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 方法二
    handelSend() {
      let formdata = new FormData();
      //   定义一个fromdata对象用于
      this.formdata = formdata;
      //   触发提交文件(执行submit()这个函数会根据有多少个文件就执行多少次http-requests所绑定的函数)
      this.$refs.upload.submit();
      this.formdata.append("something", "something");
      //   发送请求,这里上传的的是this.fromdata而不是this.fileList
    },
    uploadFile(params, type) {
      let loading;
      loading = Loading.service({
        lock: true,
        text: "",
        background: "rgba(0, 0, 0, 0.01)",
      });
      setTimeout(() => {
        if (type == "up") {
          this.content1 = this.content1new;
          this.content2 = this.content2new;
        }
        if (type == "down") {
          this.content3 = this.content3new;
          this.content4 = this.content4new;
        }
        loading.close();
      }, 2000);

      // 判断文件
      let formdata = new FormData();
      formdata.append("filename", params.file);
    },
    getSvgDetail(data) {
      d3.select("#svgId").selectAll("*").remove();
      let { nodes, links } = JSON.parse(JSON.stringify(data));
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      formatLink(links, nodes);
      formatNode(nodes);
      console.log(links,'分组前的links')
      let linkGroup = {}
      links.forEach(item=>{
        let key = item.source.name+":"+item.target.name
        if(linkGroup[key]){
          linkGroup[key].push(item)
        }else{
          linkGroup[key] = [item]
        }
      })
      console.log(linkGroup,22)
      let linkGroup2 = {
      }
      for(let i in linkGroup){
        let linkGroup2List =  Object.keys(linkGroup2)
        let res = linkGroup2List.findIndex(item=>{
          let first1 = item.split(':')[0]
          let second1 = item.split(':')[1]
          let first2 = i.split(':')[0]
          let second2 = i.split(':')[1]
          return ((first1 == first2) && (second1 == second2)) || ((first1 == second2) && (first2 == second1))
        })
        if(res > -1){
          linkGroup2[linkGroup2List[res]] = linkGroup2[linkGroup2List[res]].concat(linkGroup[i])
        }else{
          linkGroup2[i] = linkGroup[i]
        }
      }
      const simulation = d3
        .forceSimulation(nodes)
        .force("link", d3.forceLink(links).distance(380))
        .force("charge", d3.forceManyBody().strength(-300).distanceMax(380))
        .force("center", d3.forceCenter(width / 2, height / 2))
        .on("tick", tick);

      // 创建一个根容器，用于存放要画的图形
      let container = d3
        .select("#svgId")
        .append("g")
        .attr("class", "container")
        ;

      // 绘制连接线
      drawLinkPath(container, links);
      // 绘制关系文本
      drawRelationText(container, links,linkGroup2);
      // 绘制箭头
      drawMarker();
      // 圆圈和文字的外层g，可以在这个上面添加点击、hover事件
      let nodeSelection = container
        .append("g")
        .attr("class", "nodegroup")
        .selectAll(".node")
        .data(nodes)
        .enter()
        .append("g")
        .attr("id", (d) => {
          return d.idx;
        });

      // 遍历绘制圆圈和圆圈上的文本
      nodeSelection.each((d) => {
        drawCircle(d.idx);
        drawText(d.idx);
      });

      // ===== 拖拽 =====
      let dragFunc = d3
        .drag()
        .on("start", dragStarted)
        .on("drag", dragged)
        .on("end", dragend);

      dragFunc(nodeSelection);
      function dragStarted(d) {
        if (!d3.event.active) simulation.alphaTarget(0.01).restart();
        d.fx = d.x;
        d.fy = d.y;
      }
      function dragged(d) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
      }
      function dragend(d) {
        if (!d3.event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      }

      // ===== 缩放 =====
      initZoom();
      function initZoom() {
        let zoom = d3
          .zoom()
          .scaleExtent([0.6, 5])
          .on("zoom", () => {
            let transform = d3.event.transform;
            return container.attr(
              "transform",
              `translate(${transform.x},${transform.y})scale(${transform.k})`
            );
          });

        //动画持续时间
        container
          .transition()
          .duration(10)
          .call(zoom.transform, d3.zoomIdentity);
        d3.select("svg")
          .call(zoom)
          // 取消默认的双击放大事件
          .on("dblclick.zoom", null);
      }
    },
  },
  mounted() {
    if(this.$route.query.step){
      this.step = this.$route.query.step
    }
  },
  beforeDestroy() {
    this.setLeftTop(true);
    this.setRightTop(true);
  },
};
</script>
<style lang="less">
.financingInner {
  .el-pagination .el-pager .active {
    background-color: #bf9d63 !important;
    color: #fff;
  }
  .myselect {
    margin-left: 15px;
    .ivu-select {
    }
    .ivu-select-selection {
      color: #bf9d63;
      background-color: transparent;
      border: 1px solid #bf9d63;
    }
    .ivu-select-placeholder {
      color: #bf9d63 !important;
    }
  }
  .popoverBackB.el-popover {
    background: #464b54 !important;
    border-color: #464b54;
  }
  .popoverBackB .popper__arrow::after {
    /* 注意：placement位置不同，下面的属性不同 */
    border-left-color: #464b54 !important;
  }
  .platedialog .el-dialog {
    .el-dialog__title {
      color: #464b54;
    }
    background-color: #ffffff;
  }
}
</style>
<style lang="less" scoped>
@import "~@/assets/less/index.less";
.financingInner {
  .changeWrap {
    display: flex;
    align-items: center;
    padding-left: 80px;
    position: relative;
    z-index: 20;
    img {
      width: 16px;
      cursor: pointer;
    }
    span {
      cursor: pointer;
      padding-left: 5px;
      font-size: 14px;
      color: #bf9d63;
    }
  }
  .hoverContent {
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgb(147, 147, 153, 0.5);
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    .hovertitle {
      color: #fff;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 10px;
    }
    .line {
      margin: 10px auto;
      height: 1px;
      flex-shrink: 0;
      opacity: 0.14;
      background: #fff;
    }
    .content {
      color: #b3b3b3;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .padding1 {
    //   padding-top: 0.5vw;
    //   padding-bottom: 0.5vw;
    height: 2vw;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .borderLeft {
    border-left: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderTop {
    border-top: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderRight {
    border-right: solid 2px rgba(87, 87, 87, 0.5);
  }
  .borderBottom {
    border-bottom: solid 2px rgba(87, 87, 87, 0.5);
  }
  .part2 {
    .tableWrap {
      background: #2c3136;
      height: 60vh;
      margin-top: 1.5vw;
      font-weight: 600;
      border: solid 2px rgba(87, 87, 87, 0.5);

      .tableList {
        overflow-x: hidden;
        text-align: center;
        .titleWrap {
          display: flex;
          align-items: center;
          background: rgba(87, 87, 87, 0.5);
          color: #bf9d63;
        }
        .tableContentRow {
          display: flex;
          align-items: center;
          border-right: solid 2px rgba(87, 87, 87, 0.5);
          border-left: solid 2px rgba(87, 87, 87, 0.5);
          border-bottom: solid 2px rgba(87, 87, 87, 0.5);

          .tableItem {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            height: 2vw;
            width: 8vw;
            border-right: solid 2px rgba(87, 87, 87, 0.5);
          }
        }
      }
    }
    .topList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item {
        width: 12vw;
        height: 7vw;
        flex-shrink: 0;
        border: 1px solid #4d4a48;
        background: rgba(87, 87, 87, 0.3);
        display: inline-block;
        .itemTitle {
          color: #bf9d63;
          font-family: Microsoft YaHei;
          font-size: 1vw;
          font-weight: 600;
        }
        .content {
          margin-top: 0.8vw;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .num {
            color: #fff;
            font-family: Microsoft YaHei;
            font-size: 2vw;
            font-style: normal;
            font-weight: 700;
            opacity: 0.8;
          }
          .unit {
            font-size: 1vw;
          }
        }
      }
    }
  }
  .content1 {
    color: #fff;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .content2 {
    color: #bf9d63;
    opacity: 0.6;
    font-size: 1vw;
    padding: 2vw;
  }
  .uploadButton {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 8vw;
    height: 2vw;
    font-size: 1vw;
    flex-shrink: 0;
    border-radius: 2px;
    border: 1px solid #bf9d63;
    background: #46423a;
    color: rgba(191, 157, 99, 1);
  }
  .yellowCorner {
    padding-left: 3%;
    padding-right: 4%;
    width: 100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding: 10px 20px;
  }
  .loadingWrap {
    margin-top: 12vh;
    text-align: center;
    .word {
      color: 999;
    }
  }
  .flow {
    height: 38vh;
    border: 1px solid #4d4a48;
    background: rgba(87, 87, 87, 0.3);
    display: flex;
    align-items: center;
    .yellowCorner {
      display: flex;
      align-items: center;
      padding: 3vh 3vw;
      padding-left: 1vw;
    }
    .flowLeft {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 7vw;
      .dot {
        border-radius: 50%;
        width: 0.5vw;
        height: 0.5vw;
        background: linear-gradient(
          180deg,
          #bf9d63 0%,
          rgba(217, 217, 217, 0) 100%
        );
        margin-right: 0.5vw;
      }
      .word {
        color: #bf9d63;
        font-size: 1vw;
      }
    }
    .flowCenter {
      position: relative;
      width: 37vw;
      height: 100%;
      background: rgba(30, 34, 41, 1);
    }
    .flowRight {
      margin-left: 5vw;
      width: 37vw;
      height: 100%;
      background: rgba(30, 34, 41, 1);
      .noContent {
        text-align: center;
        margin-top: 12vh;
        .noword {
          color: #999;
        }
      }
    }
  }
  .top {
    height: 5vh;
    .left {
      color: #bf9d63;
      font-size: 1vw;
      float: left;
    }
    .right {
      float: right;
    }
  }
}
</style>
